import { render, staticRenderFns } from "./BudgetCreatorWidget.vue?vue&type=template&id=374e521c&scoped=true"
import script from "./BudgetCreatorWidget.vue?vue&type=script&lang=js"
export * from "./BudgetCreatorWidget.vue?vue&type=script&lang=js"
import style0 from "./BudgetCreatorWidget.vue?vue&type=style&index=0&id=374e521c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e521c",
  null
  
)

export default component.exports